export const endTypes = ['NEVER', 'TO_END_OF_YEAR', 'IN_3_MONTHS', 'IN_6_MONHTS', 'IN_12_MONTHS', 'CUSTOM'] as const;
export type EndType = (typeof endTypes)[number];
